class TooManyFailedLoginsUsersController {
    static controller($scope) {
        'ngInject';

      $scope.fields = {};
      $scope.recaptcha = {};

      $scope.resourceLogin = function(loginForm) {
        if(!$scope.fields.recaptcha) {
          $scope.recaptcha.required = true;
        } else {
          $scope.recaptcha.required = false;
        }

        if(loginForm.password.$modelValue !== '1234') {
          loginForm.password.$setValidity('valid', false);
        } else {
          loginForm.password.$setValidity('valid', true);
        }

        if(!$scope.recaptcha.required && loginForm.password.$valid) {
          alert("OK! tu nastąpi przejście do wnętrza systemu");
        }
      }
    }
}

export default TooManyFailedLoginsUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/too-many-failed-logins.users.controller.js